var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArquiOrg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    "data-name": "Grupo 24",
    transform: "translate(-463 -837)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(463 837)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9",
    "data-name": "Caminho 9",
    d: "M3.75,7.125A3.375,3.375,0,0,1,7.125,3.75H10.5a3.375,3.375,0,0,1,3.375,3.375V10.5A3.375,3.375,0,0,1,10.5,13.875H7.125A3.375,3.375,0,0,1,3.75,10.5Zm0,14.625a3.375,3.375,0,0,1,3.375-3.375H10.5a3.375,3.375,0,0,1,3.375,3.375v3.375A3.375,3.375,0,0,1,10.5,28.5H7.125A3.375,3.375,0,0,1,3.75,25.125ZM18.375,7.125A3.375,3.375,0,0,1,21.75,3.75h3.375A3.375,3.375,0,0,1,28.5,7.125V10.5a3.375,3.375,0,0,1-3.375,3.375H21.75A3.375,3.375,0,0,1,18.375,10.5Zm0,14.625a3.375,3.375,0,0,1,3.375-3.375h3.375A3.375,3.375,0,0,1,28.5,21.75v3.375A3.375,3.375,0,0,1,25.125,28.5H21.75a3.375,3.375,0,0,1-3.375-3.375Z",
    transform: "translate(464.75 838.75)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArquiOrg);
export default __webpack_public_path__ + "static/media/icon_arqui-org.9021408a2c78bee08abd1e63d1a48e16.svg";
export { ForwardRef as ReactComponent };